/**
 * Allowed-domain entries for the website widget.
 *
 * Entries may be a host (`example.com`), a URL (`https://example.com/page`) or a
 * wildcard host (`*.example.com`). A wildcard matches subdomains only, never the
 * apex, and must sit above a registrable-looking domain: `*.com` or `*` would
 * allow any site and are invalid. (Existing Nemo agents were saved with entries
 * such as `https://*.com`, which protect nothing.)
 */
export function normalizeDomainEntry(entry: string): string | null {
  const raw = entry.trim().toLowerCase();
  if (!raw) return null;
  const withoutScheme = raw.replace(/^[a-z][a-z0-9+.-]*:\/\//, "");
  const host = withoutScheme.split(/[/?#]/, 1)[0] ?? "";
  return host.length > 0 ? host : null;
}

export function isValidDomainPattern(entry: string): boolean {
  const host = normalizeDomainEntry(entry);
  if (!host) return false;
  const hostname = host.replace(/:\d+$/, "");
  if (hostname.includes("*")) {
    if (!hostname.startsWith("*.")) return false;
    const rest = hostname.slice(2);
    if (rest.includes("*")) return false;
    // at least two labels after the wildcard: *.example.com yes, *.com no
    return rest.split(".").filter(Boolean).length >= 2 && /^[a-z0-9.-]+$/.test(rest);
  }
  return /^[a-z0-9.-]+$/.test(hostname) && hostname.length > 0;
}
